import { useAppSession } from '../contexts/AppSessionContext';
import axios from 'axios';

const {
  VITE_API_URL,
  VITE_FUNCTIONS_URL,
  //@ts-expect-error env is not found
} = import.meta.env;

/**
 * useUser - Returns current authenticated user from AppSession
 * Source of truth: AppSessionContext (managed by AuthBootstrap)
 */
export const useUser = () => {
  const { status, user } = useAppSession();
  
  return {
    data: user,
    isLoading: status === 'loading',
    isError: false,
  };
};

export const sendEmail = async (uid: string, email: string, server: string = ''): Promise<string> => {
  const url = (server || VITE_FUNCTIONS_URL) + 'sendEmail';
  const response = await axios.post<string>(url, { uid, email });
  return response.data;
};
